<script>
    import Carousel from 'svelte-carousel';
    import {Constans} from "../lib/Constants";
    import {Link, navigate} from "svelte-routing";
    import {apiRequest} from "../lib/Request.svelte";
    import CancelSubscriptionStep1Modal from "../components/CancelSubscriptionStep1Modal.svelte";
    import CancelSubscriptionStep2Modal from "../components/CancelSubscriptionStep2Modal.svelte";
    import CancelSubscriptionStep3Modal from "../components/CancelSubscriptionStep3Modal.svelte";
    import CancelSubscriptionStep4Modal from "../components/CancelSubscriptionStep4Modal.svelte";
    import FreeAdditionalTrialModal from "../components/FreeAdditionalTrialModal.svelte";
    import {onMount, onDestroy} from "svelte";
    import RecoverSubscription from "../components/RecoverSubscription.svelte";
    import {loadPaySelection} from "../lib/OrdersHelper";
    import {changeAutogeneratedEmail} from "../lib/ApiRequests.svelte";
    import {validateEmail} from "../lib/Common.svelte";

    import {_} from '../lib/i18n';
    import EnCancelSubscriptionModal from "../components/EnCancelSubscriptionModal.svelte";

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    export let locale = 'ru-RU';
    export let dateTimeParams = {
        timeZone: "Europe/Moscow",
    };
    export let premiumEnabled = false;

    export let analyzes = [];

    export let identity = {};
    let userUsedFreeAdditionalPeriod;
    $: identity && (userUsedFreeAdditionalPeriod = !identity.additional_spy_trial_available);

    let userUsedWeekDiscount;
    $: identity && (userUsedWeekDiscount = !identity.spy_week_discount_available);

    let subscription;
    $: identity && (subscription = identity.spy_subscription);

    let discount = {};
    $: identity && (discount = identity.discount);

    let discountValue = 0;
    $: identity && discount && (discountValue = discount.discount);

    let discountType = 0;
    $: identity && discount && (discountType = discount.type);

    onMount(() => {
        //window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: params.initTariff !== null ? 'Оплата' : $_('subscription.pageTitle'),
                    pageTitleTag: $_('subscription.pageTitleTag'),
                });
            }
        } catch (err) {
            console.error(err);
        }
        localStorage.removeItem('ru_spy_tariff_selected')
    });

    onDestroy(() => {
        params.setState({initTariff: null})
    })

    export let totalAnalyzes = 0;

    export let availableTariffs;

    export let unsubscribeDiscountValue;
    export let unsubscribeDiscountedPrice;

    export let allowedTariffs = [
        {
            type: 'spy',
            period: 7,
            analyzes: 3,
        },
        {
            type: 'spy',
            period: 30,
            analyzes: 3,
        },
        {
            type: 'spy',
            period: 180,
            analyzes: 3,
        },
    ];

    let maxAnalyzes = analyzes.length > 3 ? analyzes.length : 3;
    //$: identity && (maxAnalyzes = totalAnalyzes + identity.spy_balance);
    //$: identity && (maxAnalyzes = identity.spy_balance);

    let subscriptionStatus = 0;
    $: identity && identity.spy_subscription && (subscriptionStatus = Number(identity.spy_subscription.status));
    $: console.log(subscriptionStatus);

    let paidTill;
    $: identity && (paidTill = (new Date(identity.spy_paid_till * 1000)).toLocaleDateString(locale, dateTimeParams));

    let subscriptionCreatedAt;
    $: identity && identity.spy_subscription && (subscriptionCreatedAt = identity.spy_subscription.created_at);

    let subscriptionPrice = 0;
    $: identity && identity.spy_subscription && (subscriptionPrice = identity.spy_subscription.price);

    let subscriptionIsActive = false;
    $: subscriptionStatus && (subscriptionIsActive = [
        Constans.spySubscriptionStatuses.ACTIVE,
        Constans.spySubscriptionStatuses.ERROR,
        Constans.spySubscriptionStatuses.PROCESS,
    ].includes(subscriptionStatus));

    let subscriptionIsRecoverable = false;
    $: subscriptionStatus && identity.spy_paid_till && (subscriptionIsRecoverable = (new Date(identity.spy_paid_till * 1000)) > (new Date()));
    let subscriptionIsCancelled = false;
    $: subscriptionStatus && (subscriptionIsCancelled = (subscriptionStatus === Constans.spySubscriptionStatuses.CANCELED));


    let subscriptionTariff = {};
    $: identity && identity.spy_subscription && (subscriptionTariff = identity.spy_subscription.tariff);

    let subscriptionWasRevived = false;

    let showSubscriptionCancelStep1Modal = false;
    let showSubscriptionCancelStep2Modal = false;
    let showSubscriptionCancelStep3Modal = false;
    let showSubscriptionCancelStep4Modal = false;
    let showReceivedAdditionalTrialModal = false;
    function initSubscriptionCancellation() {
        showSubscriptionCancelStep2Modal = false;
        showSubscriptionCancelStep3Modal = false;
        showSubscriptionCancelStep4Modal = false;
        showSubscriptionCancelStep1Modal = true;

        //window.scrollTo(0, 0);
    }

    let showSubscriptionSettings = false;
    $: showSubscriptionSettings = identity.spy_subscription && locale === 'ru-RU' && !subscriptionIsCancelled;
    function toggleSubscriptionSettingsBlock() {
        showSubscriptionSettings = !showSubscriptionSettings;
    }

    function getTariffName(tariff) {
        if (!tariff) return '-';

        if (tariff.type === 'spy') {
            return tariff.period + ' ' + $_('subscription.daysText');
        }

        return tariff ? tariff.type : '-';
    }

    function isTariffAllowed(tariff) {
        if (!availableTariffs || !availableTariffs.spy) return false;
        for (let key in availableTariffs.spy) {
            const targetTariff = availableTariffs.spy[key][3];
            for (let checkKey in allowedTariffs) {
                const checkTariff = allowedTariffs[checkKey];
                if (checkTariff.type === targetTariff.type && checkTariff.period === targetTariff.period && checkTariff.analyzes === targetTariff.analyzes) {
                    if (tariff.type === checkTariff.type && tariff.period === checkTariff.period && tariff.analyzes === checkTariff.analyzes) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    function getTariffByPeriod(period) {
        if (!availableTariffs || !availableTariffs.spy || !availableTariffs.spy[period]) return {};

        const tariff = availableTariffs.spy[period][3];

        return tariff;
    }

    function isTariffActive(tariff) {
        if (!identity || !identity.spy_subscription) return false;

        if (identity.spy_subscription.type === 'premium' && tariff.type === 'premium') return true;

        if (tariff.type === identity.spy_subscription.tariff.type &&
            Number(tariff.period) === Number(identity.spy_subscription.tariff.period) &&
            Number(tariff.analyzes) === Number(identity.spy_subscription.tariff.analyzes) &&
            subscriptionIsRecoverable) return true;

        return false;
    }

    function selectTariff(key) {
        if (selectedTariffKey === key) {
            selectedTariffKey = '';
        } else {
            selectedTariffKey = key
        }

        try {
            window.scrollTo({
                left: 0,
                top: 400,
                behavior: "smooth",
            });
        } catch (err) {}
    }

    async function initPayment() {
        errorText = '';
        if (identity.is_temporary_email && (email.length < 7 || !validateEmail(email)) && params.initTariff !== null) {
            errorText = 'Неверный формат email';
            return;
        }
        if (identity.is_temporary_email) {
            // if (params.initTariff === null) {
            //     navigate(`${path}/dashboard/settings`);
            //     return;
            // } else {
                try {
                    const changeEmailResponse = await changeAutogeneratedEmail(email);
                    if (changeEmailResponse.status === 'ok') {
                        params.changeTemporaryEmail(email);
                    } else {
                        errorText = changeEmailResponse.message;
                        return;
                    }
                } catch (err) {
                    console.error(err);
                }
            //}
        }

        let response = null;
        if (selectedTariffKey === 'premium') {
            response = await apiRequest('POST', '/instashpion/payments-api/buy-premium', (new URLSearchParams({
                'data[source]': 'dashboard',
                'data[agent]': window.shared.testGroupPaySelection === 'b' ? 'payselection' : 'yandex_kassa',
                'data[use_cash_back]': null,
            })).toString());
        } else {
            response = await apiRequest('POST', '/instashpion/payments-api/buy-spy', (new URLSearchParams({
                'data[source]': 'dashboard',
                'data[agent]': window.shared.testGroupPaySelection === 'b' ? 'payselection' : 'yandex_kassa',
                'data[use_cash_back]': null,
                'data[enable_self_analyze]': 0,
                'data[prevent_unsubscribe]': 0,
                'tariff[analyzes]': 3,
                'tariff[period]': selectedTariffKey,
            })).toString());
        }

        if (response && response.status === 'ok') {
            // Оплата через payselection
            if (response.hasOwnProperty('config') && response.config.hasOwnProperty('agent') && response.config.agent === 'payselection') {
                const timer = setInterval(() => {
                    console.log('tick');
                    if (window.pw) {
                        loadPaySelection(response.config, response.invoiceId, 0)
                        clearInterval(timer);
                        console.log('cleared');
                    }
                }, 250);
                return;
            }

            navigate(response.config.redirect);
        } else {
            errorText = $_('subscription.unknownError');
        }
    }

    let premiumTariff;
    $: availableTariffs && (premiumTariff = availableTariffs.premium);



    let subscriptionTariffName = '-';
    $: identity && identity.spy_subscription && (subscriptionTariffName = getTariffName(identity.spy_subscription.tariff));

    let selectedTariffKey = params.initTariff;
    let termsAccepted = false;
    let errorText = '';

    let reviveInProgress = false;
    let email = '';

    let showChangeTempEmailModal = false;

    let isSubscriptionNotExpired = identity && ((identity.spy_paid_till * 1000) > Date.now());
</script>

<style>
    .refund-request-block__btn {
        padding: 0;
        text-align: left;
        width: fit-content
    }

    .refund-request-p {
        margin-bottom: 16px;
    }

    .refund-request-tail {
        margin-top: 16px;
    }

    .plan-card__body:hover {
        cursor: pointer;
    }

    .plan-card__body:hover .button_ghost {
        background: var(--color-green-deepest);
        color: var(--color-white);
    }

    .plans__confirm-agreement-text {
        cursor: pointer;
    }

    @media screen and (max-width: 1113px) {
        .only-desktop-show {
            display: none;
        }
        .only-mobile-show {
            display: block;
        }
        .canvas__col_left {
            order: 2;
        }
        .canvas__col_right {
            order: 1;
            margin-bottom: 20px;
        }
    }
    @media screen and (min-width: 1114px) {
        .only-desktop-show {
            display: block;
        }
        .only-mobile-show {
            display: none;
        }
    }
</style>

{#if params.initTariff === null}
    <div class="canvas__col canvas__col_left">
        <section class="page-title only-desktop-show">{$_('subscription.payForAccess')}</section>
        {#if subscription && subscriptionIsCancelled && isSubscriptionNotExpired}
            <RecoverSubscription {params} {identity}/>

            <section class="subscription-info-block tail">
                <p class="subscription-info-block__text tail__text"><span>{$_('subscription.totalTargetsLabel')}: </span>{analyzes.length} из {maxAnalyzes}</p>
                <p class="subscription-info-block__text tail__text"><span>{$_('subscription.paidTillLabel')}: </span>{paidTill}</p>
                <p class="subscription-info-block__text tail__text"><span>{$_('subscription.currentTariffLabel')}: {subscriptionTariffName}</span></p>
            </section>
        {/if}

        {#if subscriptionWasRevived}
        <section class="subscription-renewal-block tail">
            <h2 class="subscription-renewal-block__title tail__title">{$_('subscription.subscriptionRecoveredSuccessfully')}</h2>
            <p class="subscription-renewal-block__text tail__text">{$_('subscription.subscriptionRecoveredDescription')}</p>
        </section>
        {/if}

        <section class="reviews swiper">
            <div class="reviews-wrapper swiper-wrapper">

                <Carousel arrows={false} autoplay={true} autoplayDuration="10000" loop={true}>
                    {#each Constans.reviews[locale] as review}
                        <div class="reviews-item swiper-slide">
                            <div class="reviews-item__stats-wrapper">
                                <div class="reviews-item__stats-item reviews-item__stats-item_like">
                                    <div class="reviews-item__stats-icon">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.25 7.75C2.25 7.19772 2.69772 6.75 3.25 6.75H5.25V15.75H3.25C2.69772 15.75 2.25 15.3023 2.25 14.75V7.75Z" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M5.25 8.25V14.25L6.4923 15.0782C7.14937 15.5162 7.9214 15.75 8.7111 15.75H11.7086C13.1751 15.75 14.4267 14.6898 14.6678 13.2432L15.3619 9.0788C15.565 7.85973 14.625 6.75 13.3891 6.75H10.5" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M10.5 6.75L11.0154 4.17312C11.1494 3.50293 10.7634 2.83781 10.115 2.62168V2.62168C9.47524 2.40841 8.77597 2.69806 8.47436 3.30127L6 8.25H5.25" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <div class="reviews-item__stats-number">+{review.up}</div>
                                </div>
                                <div class="reviews-item__stats-item reviews-item__stats-item_dislike">
                                    <div class="reviews-item__stats-icon">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.75 10.25C15.75 10.8023 15.3023 11.25 14.75 11.25H12.75V2.25H14.75C15.3023 2.25 15.75 2.69772 15.75 3.25V10.25Z" stroke="#88879B" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12.75 9.75V3.75L11.5077 2.9218C10.8506 2.48375 10.0786 2.25 9.2889 2.25H6.29138C4.82486 2.25 3.57329 3.31024 3.3322 4.7568L2.63813 8.9212C2.43496 10.1403 3.37504 11.25 4.61092 11.25H7.5" stroke="#88879B" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.5 11.25L6.98462 13.8269C6.85059 14.4971 7.23657 15.1622 7.88496 15.3783V15.3783C8.52476 15.5916 9.22403 15.3019 9.52564 14.6987L12 9.75H12.75" stroke="#88879B" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <div class="reviews-item__stats-number">-{review.down}</div>
                                </div>
                            </div>
                            <p class="reviews-item__text">{review.text}</p>
                            <div class="reviews-item__user-wrapper">
                                <img src={review.photo} alt="" class="reviews-item__user-avatar" />
                                <p class="reviews-item__user-name">{review.name}</p>
                            </div>
                        </div>
                    {/each}
                </Carousel>
            </div>
            <div class="reviews__pagination swiper-pagination"></div>
        </section>

        {#if subscription && !subscriptionIsCancelled && subscriptionStatus !== Constans.spySubscriptionStatuses.ERROR}
            <section class="subscription-info-block tail">
                <p class="subscription-info-block__text tail__text"><span>{$_('subscription.totalTargetsLabel')}: </span>{analyzes.length} из {maxAnalyzes}</p>
                <p class="subscription-info-block__text tail__text"><span>{$_('subscription.paidTillLabel')}: </span>{paidTill}</p>
                <p class="subscription-info-block__text tail__text"><span>{$_('subscription.currentTariffLabel')}: </span>{subscriptionTariffName}</p>

                {#if locale !== 'ru-RU'}
                    <button on:click={toggleSubscriptionSettingsBlock} class="button button_textual subscription-info-block__btn">
                        {$_('subscription.subscriptionControlLabel')}
                    </button>
                {/if}
            </section>
        {/if}

        {#if showSubscriptionSettings}
            <section class="subscription-managment tail">
                <h2 class="subscription-managment__title tail__title">{$_('subscription.subscriptionControlLabel')}</h2>

                <p class="subscription-managment__text tail__text">{@html $_('subscription.currentSubscriptionTariffDescription', {
                    values: {
                        subscriptionTariffName,
                        subscriptionPrice,
                        paidTill
                    }
                })}</p>
                <p class="subscription-managment__text tail__text"><span>{$_('subscription.paidTillLabel')}: </span>{paidTill}</p>

                <Link to={`${path}/dashboard`} class="button button_shadow subscription-managment__btn-main">
                    {$_('subscription.goToHomeBtnLabel')}
                </Link>
                <button on:click={initSubscriptionCancellation} class="button button_textual subscription-managment__btn-secondary">
                    {$_('subscription.cancelSubscriptionBtnLabel')}
                </button>
            </section>
        {/if}

        {#if window.settings.locale === 'en-US'}
            <section class="tail refund-request-tail">
                <h2 class="tail__title">14-day money-back guarantee</h2>
                <p class="refund-request-p">
                    You can apply for a refund within 14 days from the date of the first payment if your experience with DataJam turned out to be unsatisfactory for you
                </p>
                <button class="button button_textual refund-request-block__btn" on:click={() => { OmniWidgetApi.call('open_widget'); }}>
                    refund request
                </button>
            </section>
        {/if}
    </div>
{/if}

<div class="canvas__col canvas__col_right">
    <section class="page-title only-mobile-show">{$_('subscription.payForAccess')}</section>
    <section class="plans">

        {#if params.initTariff === null}
            <h4 class="plans__title">
                {$_('subscription.availablePlansDescription')}
            </h4>
        {:else}
            <section class="page-title">{$_('subscription.payForAccess')}</section>
        {/if}
        <div class="plans__cards-wrapper">
            <!-- 7 дней. Пример активной карточки -->
            {#if Number(params.initTariff) === 7 || params.initTariff === null}
                <div class={`plan-card ${selectedTariffKey === 7 ? 'select' : ''}`} on:click={() => selectTariff(7)}>
                    <div class="plan-card__flags">
                        {#if isTariffActive(getTariffByPeriod(7))}
                            <div class="plan-card__flags-item plan-card__flags-item_green">{$_('subscription.tariffIsActiveLabel')}</div>
                        {:else}
                            <div class="plan-card__flags-item plan-card__flags-item_red">-20%</div>
                        {/if}
                    </div>
                    <div class="plan-card__body">
                        <h4 class="plan-card__title">{$_('subscription.7daysPlan.period')}</h4>
                        <div class="plan-card__controls-wrapper">
                            <div class="plan-card__price">
                                <p class="plan-card__price-current">{(getTariffByPeriod(7).totalPrice * ((100 - discountValue) / 100)).toFixed(2)}{$_('subscription.currencySymbol')}</p>
                                <p class="plan-card__price-old">{$_('subscription.7daysPlan.price')}</p>
                            </div>

                            {#if isTariffActive(getTariffByPeriod(7))}
                                <button disabled class="button button_ghost plan-card__btn">{$_('subscription.isActiveLabel')}</button>
                            {:else}
                                <button class="button button_ghost plan-card__btn">
                                    {#if selectedTariffKey === 7}
                                        {$_('subscription.isSelectedLabel')}
                                    {:else}
                                        {$_('subscription.notSelectedLabel')}
                                    {/if}
                                </button>
                            {/if}
                        </div>
                    </div>
                </div>
            {/if}

            <!-- 1 месяц -->
            {#if Number(params.initTariff) === 30 || params.initTariff === null}
                <div class={`plan-card ${selectedTariffKey === 30 ? 'select' : ''}`} on:click={() => selectTariff(30)}>
                    {#if isTariffActive(getTariffByPeriod(30))}
                    <div class="plan-card__flags">
                        <div class="plan-card__flags-item plan-card__flags-item_green">{$_('subscription.tariffIsActiveLabel')}</div>
                    </div>
                    {/if}
                    <div class="plan-card__body">
                        <h4 class="plan-card__title">{$_('subscription.1monthPlan.period')}</h4>
                        <div class="plan-card__controls-wrapper">
                            <div class="plan-card__price">
                                <p class="plan-card__price-current">{(getTariffByPeriod(30).totalPrice * ((100 - discountValue) / 100)).toFixed(2)}{$_('subscription.currencySymbol')}</p>
                            </div>

                            {#if isTariffActive(getTariffByPeriod(30))}
                                <button disabled class="button button_ghost plan-card__btn">{$_('subscription.isActiveLabel')}</button>
                            {:else}
                                <button class="button button_ghost plan-card__btn">
                                    {#if selectedTariffKey === 30}
                                        {$_('subscription.isSelectedLabel')}
                                    {:else}
                                        {$_('subscription.notSelectedLabel')}
                                    {/if}
                                </button>
                            {/if}
                        </div>
                    </div>
                </div>
            {/if}

            {#if (getTariffByPeriod(180).totalPrice) && params.initTariff === null}
                <!-- 6 месяцев. Пример выбранной карточки -->
                <div class={`plan-card ${selectedTariffKey === 180 ? 'select' : ''}`} on:click={() => selectTariff(180)}>
                    <div class="plan-card__flags">
                        {#if isTariffActive(getTariffByPeriod(180))}
                            <div class="plan-card__flags-item plan-card__flags-item_green">{$_('subscription.tariffIsActiveLabel')}</div>
                        {:else}
                            <div class="plan-card__flags-item plan-card__flags-item_red">-25%</div>
                        {/if}
                    </div>
                    <div class="plan-card__body">
                        <h4 class="plan-card__title">{$_('subscription.6monthsPlan.period')}</h4>
                        <div class="plan-card__controls-wrapper">
                            <div class="plan-card__price">
                                <p class="plan-card__price-current">{(getTariffByPeriod(180).totalPrice * ((100 - discountValue) / 100)).toFixed(2)}{$_('subscription.currencySymbol')}</p>
                                <p class="plan-card__price-old">{$_('subscription.6monthsPlan.price')}</p>
                            </div>

                            {#if isTariffActive(getTariffByPeriod(180))}
                                <button disabled class="button button_ghost plan-card__btn">{$_('subscription.isActiveLabel')}</button>
                            {:else}
                                <button  class="button button_ghost plan-card__btn">
                                    {#if selectedTariffKey === 180}
                                        {$_('subscription.isSelectedLabel')}
                                    {:else}
                                        {$_('subscription.notSelectedLabel')}
                                    {/if}
                                </button>
                            {/if}
                        </div>
                    </div>
                </div>
            {/if}

            {#if premiumEnabled}
                <!-- Премиум -->
                <div class={`plan-card ${selectedTariffKey === 'premium' ? 'select' : ''}`}>
                    <div class="plan-card__flags">
                        <div class="plan-card__flags-item plan-card__flags-item_blue">{$_('subscription.isRecommendedLabel')}</div>
                    </div>
                    <div class="plan-card__body">
                        <h4 class="plan-card__title">{$_('subscription.premiumPlan.title')}</h4>
                        <p class="plan-card__text">{@html $_('subscription.premiumPlan.description')}</p>
                        <a href="/premium-info" class="plan-card__link">{$_('subscription.aboutTariffBtnLabel')}</a>
                        <div class="plan-card__controls-wrapper">
                            <div class="plan-card__price">
                                <p class="plan-card__price-current">{(premiumTariff.totalPrice * ((100 - discountValue) / 100)).toFixed(2)}{$_('subscription.currencySymbol')}/{$_('subscription.shortMonthLabel')}</p>
                            </div>

                            {#if isTariffActive(premiumTariff)}
                                <button disabled class="button button_ghost plan-card__btn">{$_('subscription.isActiveLabel')}</button>
                            {:else}
                                <button on:click={() => selectTariff('premium')} class="button button_ghost plan-card__btn">
                                    {#if selectedTariffKey === 'premium'}
                                        {$_('subscription.isSelectedLabel')}
                                    {:else}
                                        {$_('subscription.notSelectedLabel')}
                                    {/if}
                                </button>
                            {/if}
                        </div>
                    </div>
                </div>
            {/if}
        </div>
        <div class="plans__confirm">
            {#if selectedTariffKey}
                <div class="plans__confirm-plan">
                    {#if params.initTariff === null}
                        <h4 class="plans__confirm-plan-title">{$_('subscription.yourChoiceLabel')}:</h4>
                    {/if}
                    {#if selectedTariffKey === 7}
                        <p class="plans__confirm-plan-text">
                            {@html $_('subscription.7daysPlan.fullDescription', {
                                values: { totalPrice: (getTariffByPeriod(7).totalPrice * ((100 - discountValue) / 100)).toFixed(2) }
                            })}
                        </p>
                    {/if}
                    {#if selectedTariffKey === 30}
                        <p class="plans__confirm-plan-text">
                            {@html $_('subscription.1monthPlan.fullDescription', {
                                values: { totalPrice: (getTariffByPeriod(30).totalPrice * ((100 - discountValue) / 100)).toFixed(2) }
                            })}
                        </p>
                    {/if}
                    {#if selectedTariffKey === 180}
                        <p class="plans__confirm-plan-text">
                            {@html $_('subscription.6monthsPlan.fullDescription', {
                                values: { totalPrice: (getTariffByPeriod(180).totalPrice * ((100 - discountValue) / 100)).toFixed(2) }
                            })}
                        </p>
                    {/if}
                    {#if selectedTariffKey === 'premium'}
                        <p class="plans__confirm-plan-text">
                            {@html $_('subscription.premiumPlan.fullDescription', {
                                values: { totalPrice: (premiumTariff.totalPrice * ((100 - discountValue) / 100)).toFixed(2) }
                            })}
                        </p>
                    {/if}
                    <p class="plans__confirm-plan-text"></p>
                </div>
            {/if}
            <div class="plans__confirm-agreement">
                <label class="general-checkbox plans__confirm-agreement-checkbox">
                    <input class="general-checkbox__input" type="checkbox" bind:checked={termsAccepted} />
                    <div class="general-checkbox__checkmark"></div>
                </label>
                <p class="plans__confirm-agreement-text" on:click={() => {termsAccepted = !termsAccepted}}>
                    {@html $_('subscription.termsAcceptanceLabel')}
                </p>
            </div>
            {#if identity.is_temporary_email}
                <div>
                    <input bind:value={email} type="email" class="general-input account-settings__form-email-input"
                        placeholder="Введите e-mail для регистрации" style="width: 100%">
                </div>
            {/if}
            <div class="plans__confirm-controls">
                <button on:click={initPayment} disabled={!selectedTariffKey || !termsAccepted}
                        class="button button_shadow plans__confirm-controls-btn">
                    {$_('subscription.buyBtnLabel')}
                </button>
                <div class="plans__confirm-controls-disclaimer">
                    {#if params.initTariff === null}
                        <p class="plans__confirm-controls-help">{$_('subscription.selectTariffLabel')}</p>
                    {/if}
                    {#if errorText}
                        <p class="plans__confirm-controls-error">{errorText}</p>
                    {/if}
                </div>
            </div>
        </div>
    </section>
</div>

{#if locale === 'ru-RU'}
    <CancelSubscriptionStep1Modal paidTill={paidTill}
                                  bind:show={showSubscriptionCancelStep1Modal}
                                  bind:showNextModal={showSubscriptionCancelStep2Modal}/>
{:else}
    <EnCancelSubscriptionModal paidTill={paidTill}
                               bind:show={showSubscriptionCancelStep1Modal}
                               bind:showNextModal={showSubscriptionCancelStep2Modal}
                               bind:params={params}
                               bind:showSubscriptionSettings
    />
{/if}

{#if userUsedFreeAdditionalPeriod}
    <CancelSubscriptionStep2Modal paidTill={paidTill}
          bind:show={showSubscriptionCancelStep2Modal}
          bind:showNextModal={showSubscriptionCancelStep3Modal} />
{:else}
    <CancelSubscriptionStep2Modal paidTill={paidTill}
          bind:show={showSubscriptionCancelStep2Modal}
          bind:showNextModal={showSubscriptionCancelStep4Modal} />
{/if}

<CancelSubscriptionStep3Modal paidTill={paidTill}
      bind:params={params}
      bind:show={showSubscriptionCancelStep3Modal}
      bind:showNextModal={showSubscriptionCancelStep4Modal}
      discountedPrice={unsubscribeDiscountedPrice}
      discountValue={unsubscribeDiscountValue}
      bind:showSubscriptionSettings />

<CancelSubscriptionStep4Modal paidTill={paidTill}
      bind:params={params}
      bind:show={showSubscriptionCancelStep4Modal}
      bind:showNextModal={showReceivedAdditionalTrialModal}
      bind:showSubscriptionSettings  />

<FreeAdditionalTrialModal paidTill={paidTill}
      bind:show={showReceivedAdditionalTrialModal} />
